var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconMicrosoftAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_8050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1439 30.1504H1.85594C0.837433 30.1504 0.0179443 29.3241 0.0179443 28.3102V1.99059C0.0179443 0.970863 0.843286 0.150391 1.85594 0.150391H28.1439C29.1625 0.150391 29.9819 0.976724 29.9819 1.99059V28.3102C29.9819 29.3299 29.1625 30.1504 28.1439 30.1504Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6282 9.52161C20.6282 9.60952 20.6282 9.69157 20.6223 9.77947C19.9433 9.63296 19.235 9.51575 18.5033 9.42198C18.4507 7.52903 16.9053 6.01116 15.003 6.01116C13.1006 6.01116 11.5494 7.52903 11.5026 9.42198C10.7709 9.51575 10.0626 9.63296 9.38361 9.77947C9.37775 9.69157 9.37775 9.60366 9.37775 9.51575C9.37775 6.40381 11.8948 3.87793 15.0088 3.87793C18.1053 3.88965 20.6282 6.40967 20.6282 9.52161ZM15.0264 26.4233C24.9656 22.2389 23.4495 11.5845 23.4495 11.5845C21.1316 10.7172 18.2048 10.2014 15.0147 10.2014C11.8245 10.2014 8.89777 10.7172 6.57979 11.5845C6.57979 11.5845 5.06373 22.2389 15.003 26.4233H15.0264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7658 19.7132C17.7658 19.8363 17.7599 19.9535 17.7423 20.0707H12.281C12.2635 19.9535 12.2576 19.8363 12.2576 19.7132C12.2576 18.4708 13.0771 17.4218 14.2068 17.076C13.4459 16.7595 12.9074 16.0094 12.9074 15.1303C12.9074 13.9641 13.8498 13.0264 15.0088 13.0264C16.1678 13.0264 17.1102 13.9699 17.1102 15.1303C17.1102 16.0094 16.5717 16.7595 15.8107 17.076C16.9463 17.4159 17.7658 18.4708 17.7658 19.7132Z",
    fill: "#0078D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_8050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.150391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconMicrosoftAuth);
export default __webpack_public_path__ + "static/media/TH-Icon-MicrosoftAuth.f9f399144b9ffdc6fb89b2cecbb8e2e5.svg";
export { ForwardRef as ReactComponent };